@if ($visible()) { @if (deviceService.$isMobile()) {
<lib-bottom-sheet
  [visible]="$visible()"
  [modal]="true"
  [closeOnBackdrop]="false"
  [closeOnEscape]="false"
  [preventClose]="true"
  [showHandle]="true"
  size="full"
  [headerTemplate]="headerTpl"
  [footerTemplate]="footerTpl"
>
  <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</lib-bottom-sheet>
} @else {
<p-dialog
  [visible]="$visible()"
  [closable]="false"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="termo-aceite-dialog"
  [style]="{ width: '680px', maxWidth: '95vw'}"
>
  <!-- HEADER -->
  <ng-template pTemplate="header">
    <ng-container *ngTemplateOutlet="headerTpl"></ng-container>
  </ng-template>

  <!-- CONTEÚDO -->
  <ng-container *ngTemplateOutlet="contentTpl"></ng-container>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <ng-container *ngTemplateOutlet="footerTpl"></ng-container>
  </ng-template>
</p-dialog>
}

<!-- HEADER TEMPLATE -->
<ng-template #headerTpl>
  @if ($recusado()) {
  <div class="ta-header ta-header--recusado">
    <i class="pi pi-ban ta-header__icon"></i>
    <span>Acesso bloqueado</span>
  </div>
  } @else {
  <div class="ta-header">
    <i class="pi pi-shield ta-header__icon"></i>
    <div class="ta-header__info">
      @if ($termoAtual()) {
      <span class="ta-header__titulo">{{ $termoAtual()!.titulo }}</span>
      <span class="ta-header__versao">Versão {{ $termoAtual()!.versao }}</span>
      } @else {
      <span class="ta-header__titulo">Termos pendentes</span>
      }
    </div>
    <!-- @if ($progresso() > 1) {
          <span class="ta-header__contador">1 de {{ $progresso() + 1 }}</span>
        } -->
  </div>
  }
</ng-template>

<!-- CONTENT TEMPLATE -->
<ng-template #contentTpl>
  @if ($recusado()) {
  <div class="ta-recusado">
    <i class="pi pi-exclamation-circle ta-recusado__icon"></i>
    <h3 class="ta-recusado__titulo">Termo recusado</h3>
    <p class="ta-recusado__mensagem">
      Como o termo foi recusado, você não poderá acessar o sistema. No próximo
      login será solicitado novamente.
    </p>
  </div>
  } @else if ($loading()) {
  <div class="ta-loading">
    <p-progressSpinner [style]="{ width: '40px', height: '40px' }" />
  </div>
  } @else if ($termoAtual()) {
  <div class="ta-conteudo">
    <p-scrollPanel
      [style]="{
        width: '100%'
      }"
    >
      <div class="ta-conteudo__texto">
        <pre class="ta-conteudo__pre">{{ $termoAtual()!.conteudo }}</pre>
      </div>
    </p-scrollPanel>
  </div>
  }
</ng-template>

<!-- FOOTER TEMPLATE -->
<ng-template #footerTpl>
  @if ($recusado()) {
  <button
    pButton
    type="button"
    label="Sair"
    icon="pi pi-sign-out"
    class="p-button-danger"
    [loading]="$processando()"
    (click)="sair()"
  ></button>
  } @else {
  <div class="ta-footer">
    <button
      pButton
      type="button"
      label="Recusar"
      icon="pi pi-times"
      class="p-button-outlined p-button-danger"
      [loading]="$processando()"
      [disabled]="$loading()"
      (click)="recusar()"
    ></button>
    <button
      pButton
      type="button"
      label="Li e aceito os termos"
      icon="pi pi-check"
      class="p-button"
      [loading]="$processando()"
      [disabled]="$loading()"
      (click)="aceitar()"
    ></button>
  </div>
  }
</ng-template>
}
